import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import annotationPlugin from "chartjs-plugin-annotation";

import { Line } from "react-chartjs-2";
import { color } from "@mui/system";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  annotationPlugin
);

export function MultipleLineChart({ config, width, height }) {
  const isMobile = () => {
    return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  };
  var options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: "index",
      intersect: false,
    },
    plugins: {
      legend: {
        position: "bottom",
        align: "start",
        labels: {
          font: {
            size: isMobile() ? 14 : 18,
            weight: 600,
            family: "Plus Jakarta Sans",
          },
          usePointStyle: true,
          padding: 20,
          filter: function (item, chart) {
            return (
              !item ||
              !item.text ||
              !item.text.includes ||
              !item.text.includes("NaN")
            );
          },
        },
      },
    },
    layout: {
      padding: config.padding,
    },
    annotations: config.annotations,
    scales: {
      y: {
        beginAtZero: true,
        grid: {
          color: "rgba(112, 112, 112, 0.24)",
          lineWidth: 3,
          borderWidth: 0,
        },
        ticks: {
          font: {
            size: isMobile() ? 14 : 18,
            weight: 600,
            family: "Plus Jakarta Sans",
          },
          maxTicksLimit: 8,
          stepSize: 25,
          color: "#919191",
          padding: 30,

          callback: function (val, index) {
            // Hide the label of every 2nd dataset
            return val + "%";
          },
        },
      },
      x: {
        grid: {
          display: false,
        },
        ticks: {
          font: {
            size: isMobile() ? 14 : 18,
            weight: 600,
            family: "Plus Jakarta Sans",
          },
          maxRotation: 45, // or any angle you prefer
          minRotation: 45, // make it the same as maxRotation to fix the angle
          color: "#919191",
          padding: 20,
        },
      },
    },
  };
  const getData = () => {
    if (config.hideXTicks) {
      options.scales.x.ticks.display = false;
    } else {
      options.scales.x.ticks.display = true;
    }

    if (config.yTicksCallback) {
      options.scales.y.ticks.callback = config.yTicksCallback;
    }

    if (config.yTicksStepSize) {
      options.scales.y.ticks.stepSize = config.yTicksStepSize;
    }

    if (config.elements != undefined) {
      options.elements = config.elements;
    }

    if (config.plugins) {
      options.plugins = { ...options.plugins, ...config.plugins };
    }

    var datasets = [];

    config.fill.forEach((d) => {
      const mobileSize = 1; // Adjust this value as needed for mobile
      const defaultSize = d.pointRadius || 4; // Use the existing size or a default

      datasets.push({
        label: d.title,
        data: d.data,
        backgroundColor: d.color,
        borderColor: d.color,
        borderWidth: 5,
        tension: 0.4,
        radius: 4,
        pointStyle: d.pointStyle,
        pointRadius: isMobile() ? mobileSize : defaultSize,
        pointHoverRadius: isMobile() ? mobileSize : defaultSize,
        pointHitRadius: isMobile() ? mobileSize : defaultSize,
        borderDash: d.borderDash,
      });
    });

    return {
      labels: config.labels,
      datasets: datasets,
    };
  };

  const data = getData();

  return <Line options={options} data={data} height={height} width={width} />;
}
